import { useEffect, useState, useRef } from "react";
import styles from "./image-carousel.module.scss";
import { Image, Text } from "components/commons";
import { extractDirectoryWithFile } from "components/commons/select-file/select-file";
import { ImageSharp } from "@material-ui/icons";
import clsx from "clsx";

const ImageCarousel = ({ value, onClose }) => {
  const urls = value
    ? value
        .split(",")
        .map((url) => url.trim())
        .filter(Boolean)
    : [];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isZoomed, setIsZoomed] = useState(false);
  const [origin, setOrigin] = useState("center center");
  const imageRef = useRef(null);

  useEffect(() => {
    setCurrentIndex(0);
    setIsZoomed(false);
    setOrigin("center center");
  }, [value]);

  const handleImageClick = (e) => {
    e.stopPropagation();

    const rect = imageRef.current.getBoundingClientRect();
    const clickX = e.clientX - rect.left;
    const clickY = e.clientY - rect.top;
    const percentX = (clickX / rect.width) * 100;
    const percentY = (clickY / rect.height) * 100;

    setOrigin(`${percentX}% ${percentY}%`);
    setIsZoomed((prev) => !prev);
  };

  const handlePrev = (e) => {
    e.stopPropagation();
    setIsZoomed(false);
    setOrigin("center center");
    setCurrentIndex((prev) => (prev === 0 ? urls.length - 1 : prev - 1));
  };

  const handleNext = (e) => {
    e.stopPropagation();
    setIsZoomed(false);
    setOrigin("center center");
    setCurrentIndex((prev) => (prev === urls.length - 1 ? 0 : prev + 1));
  };

  if (urls.length === 0) return null;

  const currentUrl = urls[currentIndex];

  return (
    <div className={styles.preview} onClick={() => onClose?.()}>
      <div className={styles.info}>
        <ImageSharp fontSize="medium" style={{ color: "white" }} />
        <Text strong color="white">
          {extractDirectoryWithFile(currentUrl)}
        </Text>
      </div>

      {urls.length > 1 && (
        <button
          className={styles.arrowLeft}
          onClick={handlePrev}
          aria-label="Previous Image"
          type="button"
        >
          &#10094;
        </button>
      )}

      <Image
        ref={imageRef}
        className={clsx(styles.image, isZoomed && styles.zoomed)}
        style={{ transformOrigin: origin }}
        onClick={handleImageClick}
        src={currentUrl}
        alt={currentUrl}
      />

      {urls.length > 1 && (
        <button
          className={styles.arrowRight}
          onClick={handleNext}
          aria-label="Next Image"
          type="button"
        >
          &#10095;
        </button>
      )}
    </div>
  );
};

export default ImageCarousel;
